// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3_faZ","file":"styles_file__tboXW"};